import React, { useCallback } from 'react';
import { MicroProductScreenView } from '@/experiences/sales-portal/domain/microproducts/screens/micro-product-screen-view';
import { NavigateToMicroproductPayload } from '@domain/microproducts/components/micro-product-webview-types';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';

export type MicroProductLoaderScreenProps = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.Base
>;

export const MicroProductLoaderScreen: React.FC<
  MicroProductLoaderScreenProps
> = ({ navigation, route }) => {
  const handleNavigateToMicroproduct = useCallback(
    (payload: NavigateToMicroproductPayload) => {
      navigation.navigate(SALES_PORTAL_ROUTES.Base, {
        productId: payload.productId,
        ...(payload.params && { microproductParams: payload.params }),
      });
    },
    [navigation],
  );

  return (
    <MicroProductScreenView
      microproductParams={route.params?.microproductParams}
      mpRoute={route.params?.mpRoute}
      navigation={navigation}
      onNavigateToMicroproduct={handleNavigateToMicroproduct}
      productId={route.params?.productId}
      Template={SalesHubShellTemplate}
    />
  );
};
